import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import axios from '../../axios-vmou';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { AutoComplete } from 'primereact/autocomplete';
import styles from '../batch/batchtable.module.css';
import { useHistory } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import logo from "../../assets/vmou.png";


const Citychange = (props) => {

    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory();
    const [globalFilter, setGlobalFilter] = useState(null);
    const [batch, setBatch] = useState(null);
    const [courseList, setCourseList] = useState(null);
    const [cityList, setCityList] = useState(null);
    const [cityListch, setCityListch] = useState([]);
    const [selectedPrCity, setSelectedPrCity] = useState(null);
    const [filteredcities, setFilteredcities] = useState(null);
    const exams = [
        "DEC25",
        "JUNE25",
        "DEC24"
    ]

    const [selectedExam, setSelectedExam] = useState(exams[0]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);

    useEffect(() => {
      let authOptions = {
        method: 'PUT',
        url: '/examiner/prCoord/'+props.userid, 
        data: {'userid':props.userid,'exam':selectedExam},
            headers : {
            'x-auth-token' : localStorage.getItem('token')
        }
    };
    axios(authOptions)
        .then(response => {
            setCourseList(response.data.prpapers)
            setCityList(response.data.prcities)
            setCityListch(response.data.prcities.map(e => e.explace))
        })
        .catch(error => {
            toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
            setCourseList([]);
        });
    },[props.userid,selectedExam]); 

    const examSearch = (event) => {
      event.preventDefault();  
     let authOptions = {
      method: 'PUT',
      url: '/batch/citychange/', 
      data: {'userid':props.userid,'exam':selectedExam, 'ccode':selectedCourse.ccode,'city':selectedCity.explace},
      headers : {
          'x-auth-token' : localStorage.getItem('token')
      }
    };
    axios(authOptions)
    .then(response => {
      setBatch(response.data);
    })
    .catch(error => {
      toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
      setBatch([]);
    });
  }
  const entrySubmitConfirm = (e) => {
    e.preventDefault();
    confirmDialog({
        message: 'Are you sure you want to Submit? These Changes will be permanent.',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => entrySubmitHandler(e),
        reject: () => rejectFunc()
    });
}
const rejectFunc = () => {
    return;
  }
  
const entrySubmitHandler = (e) => {
  let authOptions = {
    method: 'PUT',
    url: '/batch/prCityChange/', 
    data: {'ccode':selectedCourse.ccode,'exam':selectedExam,'batch':batch},
        headers : {
        'x-auth-token' : localStorage.getItem('token')
    }
  };
  axios(authOptions)
    .then(response => {
      alert("Cities Changed Successfully")
      history.goBack()
    })
    .catch(error => {
        toast.current.show({severity: 'error', summary: 'Error Message', detail: error.response.data});
    });
}


const cityValidator = (e,o) => {
  let val=(!e.value)?' ':e.value
  o.rowData.explace = val;
}
const searchCity = (event) => {
  setTimeout(() => {
      let _filteredcities;
      if (!event.query.length) {
          _filteredcities = [...cityListch];
      }
      else {
          _filteredcities = cityListch.filter((city) => {
              return city.toLowerCase().includes(event.query.trim().toLowerCase());
          });
      }

      setFilteredcities(_filteredcities);
  }, 50);
}

  const cityEditor = (options) => {
    return <AutoComplete value={selectedPrCity} suggestions={filteredcities} completeMethod={searchCity} onblur={(e) => setSelectedPrCity()} onFocus={(e) => setSelectedPrCity(options.rowData.explace)}  dropdown forceSelection onChange={(e) => cityValidator(e,options)} ></AutoComplete>
  }
  const header = (
    <div className={styles.tableheader}>
        <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
        </span>
    </div>
);

    return (
        <div >
            <Toast ref={toast} />
            <div className="Headerusr" style={{position:'sticky'}} >
          <img src={logo} alt="VMOU" height={100} width={90} style={{margin:'0px 0 0 20px'}} ></img>
          <h2 style={{marginTop:'0', textAlign:'center'}}>Regional Centre Module<br/>Practicals City Change</h2>
          <div className="Userusr" >
            <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
            <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
          </div>
        </div>
            <div className={styles.Sformpr}>
                <div className=" ">
                    <label  className="">Select Exam</label>
                    <Dropdown className="ml-2 mr-4 my-1 h-auto" value={selectedExam} options={exams} onChange={(e) => setSelectedExam(e.value)}  placeholder="Select Exam" />
                </div>
                <div className=" ">
                    <label  className="">Select Course</label>
                    <Dropdown className="ml-2 mr-4 my-1 h-auto" value={selectedCourse} options={courseList} optionLabel="ccode" onChange={(e) => setSelectedCourse(e.value)}  placeholder="Select Course" />
                </div>
                <div className=" ">
                    <label  className="">Select City</label>
                    <Dropdown className="ml-2 mr-4 my-1 h-auto" value={selectedCity} options={cityList} optionLabel='explace' onChange={(e) => setSelectedCity(e.value)}  placeholder="Select City" />
                </div>
                <Button icon="pi pi-search" tooltip="Search" className="ml-2 p-button-text p-button-success" onClick={examSearch}/>
            </div>
            <div style={{width:'30%', margin:'auto'}} className={styles.datatablecruddemo}>                <DataTable resizableColumns columnResizeMode="fit" showGridlines className="p-datatable-sm" ref={dt} value={batch} 
              dataKey="ccode" sortField="ccode" sortOrder={1} paginator rows={25} rowsPerPageOptions={[25, 50, 100]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} schnos"
              globalFilter={globalFilter} header={header} responsiveLayout="scroll">
              <Column field="schno" header="Schno" sortable style={{textAlign:'center',   width: '20%', padding:'0 1px 0 1px' }}></Column>
              <Column field="explace" header="Pr City"  editor={(options) => cityEditor(options)} sortable style={{textAlign:'center',   width: '30%' , padding:'0 1px 0 1px'}}></Column>
            </DataTable>
            <ConfirmDialog />
            <div className='flex flex-row justify-content-center'>   
              <Button  label="Submit"  className="p-button-rounded p-button-raised p-button-success mr-6" onClick={entrySubmitConfirm} />
              <Button label="Back"  className="p-button-rounded p-button-danger ml-6" onClick={()=>history.goBack()} />
            </div>
          </div>
        </div>
        );
    
}

const mapStatetoProps = (state) => {
    return {
      username:state.auth.username,
      userid:state.auth.userid,
      email:state.auth.email,
      isAuth:state.auth.token!==null,
  };
}


export default connect(mapStatetoProps)(Citychange);
